// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Styles
import theme from '../../../common/theme'

const WelcomePageWarningContainer = styled.div`

  .title {
    color: ${ theme.palette.blue };
    margin-top: 20px;
    margin-left: 20px;
    font-size: 20px;
    line-height: 23px;
    font-weight: bold;
    letter-spacing: 0.266667px;
    display: flex;
    align-items: center;
  }

  .title svg {
    margin-left: 20px;
    margin-right: 20px ;
    fill: ${ theme.palette.blue };
  }

  .content {
    font-size: 12px;
    letter-spacing: 0.13px;
    color: ${ theme.palette.black };
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    margin-bottom: 15px;
    word-break: break-word;
  }
`

export default function WelcomePageWarning({ ...props }) {
  return (
    <WelcomePageWarningContainer>
      <div className="title">
        Attention !
      </div>
      <div className="content">
        Vous n’avez actuellement aucun enfant déclaré à charge (au sens des prestations familiales) dans les
        systèmes d’information RH.
        <br/><br/>
        S’il s’agit d’une erreur, nous vous engageons à contacter votre gestion RH locale ainsi que le service SFT
        (supplément familial de traitement : <a href="mailto:sft@ratp.fr">sft@ratp.fr</a>).
        Vous pouvez cependant faire une simulation sans ouverture de droits.
      </div>
    </WelcomePageWarningContainer>
  )
}
